"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _ui = require("@alycecom/ui");

var UnsubscribeSetting = function UnsubscribeSetting(_ref) {
  var value = _ref.value,
      isLoading = _ref.isLoading,
      onSave = _ref.onSave;

  var _useState = (0, _react.useState)(value),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      localValue = _useState2[0],
      setLocalValue = _useState2[1];

  var toggleUnsubscribeHandler = (0, _react.useCallback)(function () {
    return setLocalValue(!localValue);
  }, [localValue, setLocalValue]);
  var saveHandler = (0, _react.useCallback)(function () {
    onSave(localValue);
  }, [localValue, onSave]);
  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "column"
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 5,
    container: true,
    direction: "row"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 1,
    mr: 1.5
  }, /*#__PURE__*/_react.default.createElement(_material.FormControl, null, /*#__PURE__*/_react.default.createElement(_material.FormControlLabel, {
    control: /*#__PURE__*/_react.default.createElement(_material.Checkbox, {
      checked: localValue,
      onChange: toggleUnsubscribeHandler,
      value: "enabled",
      color: "primary"
    }),
    label: "Unsubscribe from all Alyce Gifts and emails"
  })))), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 2
  }, /*#__PURE__*/_react.default.createElement(_ui.ActionButton, {
    onClick: saveHandler,
    disabled: isLoading
  }, "Save")));
};

UnsubscribeSetting.propTypes = {
  value: _propTypes.default.bool,
  isLoading: _propTypes.default.bool,
  onSave: _propTypes.default.func.isRequired
};
UnsubscribeSetting.defaultProps = {
  isLoading: false,
  value: false
};
var _default = UnsubscribeSetting;
exports.default = _default;